import LazyLoad from "vanilla-lazyload";

const templateCooperation = {
  init: function () {
    templateCooperation.switch();

    // Change img
    $(".switch").on("click", templateCooperation.model);
    templateCooperation.model();
  },

  switch: function () {
    // Change state
    $(".switch").on("click", function () {
      var btn = $(this);
      if (btn.attr("data-state") == "off") {
        btn.attr("data-state", "on");
      } else {
        btn.attr("data-state", "off");
      }
    });
  },

  model: function () {
    var btn = $(".switch");

    var simple;
    var advanced;
    if ($(window).width() < 900) {
      simple = $(".model__body .simple.mobile");
      advanced = $(".model__body .advanced.mobile");
    } else {
      simple = $(".model__body .simple").not(".mobile");
      advanced = $(".model__body .advanced").not(".mobile");
    }

    if (btn.attr("data-state") == "off") {
      LazyLoad.load(simple[0]);
      simple.fadeIn();
      advanced.hide();
    } else {
      LazyLoad.load(advanced[0]);
      simple.hide();
      advanced.fadeIn();
    }
  },
};

export default templateCooperation;
